import { createContext, Dispatch, SetStateAction } from "react";

import { GridReadyEvent } from "ag-grid-community";

export default createContext<{
  activityGridEvent?: GridReadyEvent;
  setActivityGridEvent?: Dispatch<SetStateAction<GridReadyEvent | undefined>>;
  cceActivityGridEvent?: GridReadyEvent;
  setCCEActivityGridEvent?: Dispatch<SetStateAction<GridReadyEvent | undefined>>;
  ccseActivityGridEvent?: GridReadyEvent;
  setCCSEActivityGridEvent?: Dispatch<SetStateAction<GridReadyEvent | undefined>>;
}>({});
